import { render } from "./SearchExamples.vue?vue&type=template&id=e5463d7c"
import script from "./SearchExamples.vue?vue&type=script&lang=js"
export * from "./SearchExamples.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__